import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import CanvasBoard from './components/CanvasBoard';
import RightPanel from './panels/RightPanel';
import StartModal from './components/StartModal';
import TopBar from './components/top';
import LeftBar from './components/leftbar';
import './components/top.css';
import './components/leftbar.css';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Tooltip } from '@mui/material';
import layerLibrary from './canvas/LayerLibrary';

function App() {
  const [layoutStarted, setLayoutStarted] = useState(false);
  const [isRightPanelVisible, setIsRightPanelVisible] = useState(false);
  const [verified, setVerified] = useState(null); // null = loading
  const [error, setError] = useState(null);
  const canvasRef = useRef(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  console.log("🌍 API_BASE_URL =", API_BASE_URL);




  useEffect(() => {
    if (window.location.hostname === "localhost") {
      console.log("Debug: verification skipped in development");
      setVerified(true); // Skip verification
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");
    const accessToken = localStorage.getItem("access_token");

    const cleanURL = () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    };

    const verifyWithUrlToken = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/auth/verify-token`,
          { token: urlToken },
          { withCredentials: true }
        );
        
        localStorage.setItem("access_token", res.data.access_token);
        localStorage.setItem("candidateId", res.data.candidateId); 
        const candidateId = localStorage.getItem("candidateId");
        console.log("✅ Candidate ID:", candidateId);

        setVerified(true);
        cleanURL();
      } catch (err) {
        setError(err.response?.data?.msg || "Token verification failed");
        setVerified(false);
      }
    };

    const verifyWithAccessToken = async () => {
      try {
        await axios.post(`${API_BASE_URL}/auth/verify-token`, {
          token: accessToken,
        });
        setVerified(true);
      } catch (err) {
        if (err.response?.status === 401) {
          await refreshAccessToken();
        } else {
          setError(err.response?.data?.msg || "Invalid access token");
          setVerified(false);
        }
      }
    };

    const refreshAccessToken = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/auth/refresh`,
          {},
          { withCredentials: true }
        );
        localStorage.setItem("access_token", res.data.access_token);
        setVerified(true);
      } catch (err) {
        setError("Session expired. Please login again.");
        setVerified(false);
      }
    };

    const runVerification = async () => {
      if (urlToken) {
        await verifyWithUrlToken();
      } else if (accessToken) {
        await verifyWithAccessToken();
      } else {
        setError("No token provided");
        setVerified(false);
      }
    };

    runVerification();
  }, [API_BASE_URL]);

  useEffect(() => {
    if (verified === true) {
      (async () => {
        await layerLibrary.ensureLoaded();
        console.log("✅ layers ready:", layerLibrary.getAllLayers());
      })();
    }
  }, [verified]);

  const handleStartNew = () => {
    setLayoutStarted(true);
  };

  const handleLoadJSON = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = JSON.parse(event.target.result);
        setLayoutStarted(true);
        setTimeout(() => {
          if (window.canvasEngine) {
            window.canvasEngine.loadFromJSON(data);
          }
        }, 100);
      } catch (err) {
        alert("Invalid JSON file");
      }
    };
    reader.readAsText(file);
  };

  if (window.location.hostname !== "localhost") {
    if (verified === null)
      return (
        <div style={{ padding: 20, color: "white" }}>🔒 Verifying token...</div>
      );
    if (!verified)
      return <div style={{ padding: 20, color: "red" }}>❌ {error}</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <TopBar />
      <div style={{ display: 'flex', flex: 1 }}>
        <LeftBar />
        <div style={{ flex: 1, position: 'relative', display: 'flex' }}>
  <CanvasBoard ref={canvasRef} />
  {isRightPanelVisible && <RightPanel />}
  <Tooltip
    title={isRightPanelVisible ? "Collapse" : "Expand"}
    placement="left"
  >
    <span
      style={{
        position: 'absolute',
        top: "0px",
        right: isRightPanelVisible ? '253px' : '3px',
        zIndex: 1000,
        transition: 'right 0.2s ease',
        display: 'inline-flex',
      }}
    >
      <button
        onClick={() => setIsRightPanelVisible(!isRightPanelVisible)}
        style={{
          padding: '0px',
          backgroundColor: '#2b2b2b',
          color: '#fff',
          border: '1px solid #444',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        {isRightPanelVisible ? (
          <ChevronRightIcon fontSize="small" />
        ) : (
          <ChevronLeftIcon fontSize="small" />
        )}
      </button>
    </span>
  </Tooltip>
</div>


      </div>
    </div>
  );
}

export default App;
